import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { trackPageView, isAnalyticsEnabled } from '@/lib/analytics';

/**
 * Analytics Tracker (Internal)
 *
 * Tracks page views using React Router navigation hooks.
 */
function AnalyticsTracker() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;

    // Track page view on route change
    const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '');
    trackPageView(url);
  }, [pathname, searchParams]);

  return null;
}

/**
 * Analytics Provider
 *
 * Wraps the app to provide automatic page view tracking.
 * Integrates with React Router to track client-side route changes.
 */
export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <AnalyticsTracker />
      {children}
    </>
  );
}
